export const getScrollParent = (element: HTMLElement | null) => {
	let node = element?.parentElement;
	while (node && node !== document.body) {
		const { overflowY } = window.getComputedStyle(node);
		if (overflowY === 'auto' || overflowY === 'scroll') return node;
		node = node.parentElement;
	}
	return document.documentElement;
};

export const isScrollbarClick = (event: MouseEvent) => {
	const node = event.target;
	if (!(node instanceof HTMLElement)) return false;
	const onVerticalBar = node.clientWidth > 0 && event.offsetX >= node.clientWidth;
	const onHorizontalBar = node.clientHeight > 0 && event.offsetY >= node.clientHeight;
	return onVerticalBar || onHorizontalBar;
};
